// A small filigree flourish used as a silent divider in hero + empty states.
// v1 design language: replaces the old star-constellation with a classical
// printer's ornament — a symmetric arabesque on a hairline, terracotta dots
// at the rhythm points. Renders in one ink + one accent so it matches any
// surface the Petal & Terracotta palette is applied to.
export function Constellation({ className = "" }: { className?: string }) {
  return (
    <svg
      className={className}
      width="360"
      height="40"
      viewBox="0 0 360 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M 10 20
           C 40 8, 70 32, 110 20
           C 140 12, 160 12, 170 20
           C 180 28, 200 28, 230 20
           C 270 8, 300 32, 350 20"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        fill="none"
        className="text-hairline-bold"
      />
      <circle cx="10"  cy="20" r="2.2" className="fill-terracotta" />
      <circle cx="170" cy="20" r="2.8" className="fill-terracotta" />
      <circle cx="350" cy="20" r="2.2" className="fill-terracotta" />
      <circle cx="90"  cy="20" r="1.6" className="fill-ink-faint" />
      <circle cx="250" cy="20" r="1.6" className="fill-ink-faint" />
    </svg>
  );
}
